__turbopack_context__.v({
  "container": "c-XTyG_container",
  "faqAnswer": "c-XTyG_faqAnswer",
  "faqIcon": "c-XTyG_faqIcon",
  "faqItem": "c-XTyG_faqItem",
  "faqList": "c-XTyG_faqList",
  "faqQuestion": "c-XTyG_faqQuestion",
  "header": "c-XTyG_header",
  "label": "c-XTyG_label",
  "open": "c-XTyG_open",
  "questionText": "c-XTyG_questionText",
  "rotated": "c-XTyG_rotated",
  "section": "c-XTyG_section",
  "title": "c-XTyG_title",
});
